import { render } from "./regulasi.vue?vue&type=template&id=e3d60c5c"
import script from "./regulasi.vue?vue&type=script&lang=js"
export * from "./regulasi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__